import axios from 'axios';

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Variable para mantener el setLoading global
let setLoadingGlobal = null;
let interceptorsRegistered = false; // <-- evita registrar más de una vez

export const registerLoadingHandler = (setter) => {
  setLoadingGlobal = setter;

  if (interceptorsRegistered) return; // ✅ solo una vez
  interceptorsRegistered = true;

  // Interceptor global
  apiClient.interceptors.request.use(config => {
    setLoadingGlobal(true);
    return config;
  });

  apiClient.interceptors.response.use(
    response => {
      setLoadingGlobal(false);
      return response;
    },
    error => {
      setLoadingGlobal(false);
      return Promise.reject(error);
    }
  );
};

// Obtener el setter para usarlo dentro de useApi
export const getGlobalLoadingSetter = () => setLoadingGlobal;

export default apiClient;
